<template>
    <span class="notification-bell">

              <svg class="bell" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve">
                   <g>
                     <path d="M12.9,1.9l0.4-0.4c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0l-0.4,0.4C11.2,0.4,10.2,0,9.1,0
                            c-1.5,0-3,0.7-4.2,1.9c-1.4,1.4-2.3,1.4-3,1.5c-0.5,0-1,0.1-1.4,0.5C0.1,4.2,0,4.7,0,5.1C0,5.6,0.2,6,0.6,6.4l7.1,7.1
                            C8,13.8,8.5,14,8.9,14c0.4,0,0.9-0.2,1.2-0.5c0.4-0.4,0.5-1,0.5-1.4c0.1-0.7,0.1-1.6,1.5-3C14.3,6.9,14.6,4,12.9,1.9z M2.7,13.3
                            c0.9,0.9,2.4,0.9,3.3,0L2.7,10C1.7,10.9,1.7,12.4,2.7,13.3z"/>
                   </g>
                </svg>



     <!--<span v-if="params  && params.status != 'hidden'"
              :class="'notification-text status-'+params.status"
    >{{ params.notification_message }}</span>-->
        <!--<span class="single-bell-emoji" :class="{'show':!is_hidden}">🔔</span>
      <small class="single-bell-info" :class="{'show':!is_hidden}"
      >
        <strong>{{ params.app_name }}</strong> <br>
        {{ params.received_at | moment("MMM DD, YYYY") }}  <br>      
        {{ params.received_at | moment("hh:mm") }}
        

      </small>-->
    </span>

</template>
<style lang="scss" scoped>
    .bell {
        width: 2rem;
        fill: white;
        &:hover, &:focus {
                      animation: bellshake .5s cubic-bezier(.36,.07,.19,.97) both;
                      backface-visibility: hidden;
                      transform-origin: top right;
                  }
        }

        @keyframes bellshake {
            0% { transform: rotate(0); }
            15% { transform: rotate(5deg); }
            30% { transform: rotate(-5deg); }
            45% { transform: rotate(4deg); }
            60% { transform: rotate(-4deg); }
            75% { transform: rotate(2deg); }
            85% { transform: rotate(-2deg); }
            92% { transform: rotate(1deg); }
            100% { transform: rotate(0); }
        }
</style>
<script>

    function Channel(audio_uri) {
        this.audio_uri = audio_uri;
        this.resource = new Audio(audio_uri);
    }

    Channel.prototype.play = function () {
        // Try refreshing the resource altogether
        this.resource.play();
    }

    function Switcher(audio_uri, num) {
        this.channels = [];
        this.num = num;
        this.index = 0;

        for (var i = 0; i < num; i++) {
            this.channels.push(new Channel(audio_uri));
        }
    }

    Switcher.prototype.play = function () {
        this.channels[this.index++].play();
        this.index = this.index < this.num ? this.index : 0;
    }


    export default {
        name: 'SingleBell',

        data() {

            return {

                bell: null,
                is_hidden: true

            }

        },

        props: {
            params: {
                default: null
            }

        },

        created() {

            this.bell = new Switcher('/media/bell.mp3', 10);

            //console.log("Check hidden param for element "+ this.params.id + ": ", this.params.hidden)

            this.is_hidden = this.params.hidden
            this.ringBell();

            setTimeout(() => {
                this.is_hidden = false
            }, 750);


        },

        methods: {

            ringBell() {


                this.bell.play();


            },


        },

        watch: {

            params(v, o) {
                if (v != o) this.ringBell();
                console.log("ALSO PROPS ARE CHANGING?", v, o);
            }

        }


    }
</script>

<style lang="scss">

    .single-bell {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        position: relative;


    }

    .single-bell-info {
        opacity: 0;
        text-align: center;

        &.show {
            transition: all .375s ease-in;
            transition-delay: .5s;
            opacity: 1;
        }
    }

    .single-bell-emoji {
        font-size: 7vmax;
        width: 0;
        display: inline-block;
        overflow: hidden;
        transition: all .375s ease-in;
        //transition-delay: 1s;
        opacity: 0;
        display: inline-block;

        text-align: center;

        transform-origin: top center;
        transition: transform .25s ease;
        transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);

        &:hover {
            transform: rotate(3deg);
        }

        cursor: default;

        &.show {
            opacity: 1;
            width: 9vmax;


        }


    }


</style>
